import React from 'react';
import GeneralModal from '../../../../../components/UI/modal/GeneralModal';
import AlertUser from '../../../../../components/Alerts/AlertUser';
import useTags from '../../../../../hooks/useTags';
import updateVehicleModal from '../../../../../data/lang/homePage/updateVehicleModal.lang';
import {
    useCloseVehiclePermitModal, useGetAlertStateUpdateVehiclePermitModal,
    useGetUpdateVehiclePermitModalStep,
    useIsUpdateVehiclePermitModalOpen
} from '../../../../../stores/updateVehiclePermitModal.store';
import UpdateVehicleForm from './UpdateVehicleForm';
import DisplayConfirmation from './DisplayConfirmation';
import useUpdateVehicleModalFunctions from '../../../../../hooks/useUpdateVehicleModalFunctions';
import SendFormBtm from '../../../../../components/buttons/SendFormBtm';
import ExistBtn from '../../../../../components/buttons/ExistBtn';


const UpdateVehicleModal = () => {

    const modalStep = useGetUpdateVehiclePermitModalStep();
    const alertState = useGetAlertStateUpdateVehiclePermitModal();
    const { submitUpdateVehicleForm } = useUpdateVehicleModalFunctions();

    const generateTag = useTags();
    const isVehiclePermitModalOpen = useIsUpdateVehiclePermitModalOpen();
    const closeModal = useCloseVehiclePermitModal();

    const modalTitleTag = generateTag(updateVehicleModal, 'modal-title');
    const btnLabel = 'שלח';

    const loading = alertState.alertStatus === 'loading';


    return (
        <GeneralModal
            show={isVehiclePermitModalOpen}
            closingFunc={closeModal}
            title={modalTitleTag}
            modalSize='S'
            loading={loading}
            alertUser={<AlertUser state={alertState} />}
            body={(
                <div className='container'>
                    <UpdateVehicleForm />
                    <DisplayConfirmation />
                </div>
            )}
            footer={(
                <div className='d-flex justify-content-start gap-1 p-1'>
                    <ExistBtn onClick={closeModal} />
                    <SendFormBtm
                        show={modalStep === 'form'}
                        onClick={submitUpdateVehicleForm}
                        btnLabel={btnLabel}
                        isLoading={loading}
                    />
                </div>
            )


            }
        />
    );
}

export default UpdateVehicleModal;